<template>
  <div class="position-relative mx-4 px-4 px-sm-2">
    <Proposition65WarningSymbol :left="xs ? 0 : -10" :top="4" />
    <p
      class="dont-break-out pt-1 pt-sm-0"
      :class="xs ? 'font-size-xs' : ''"
      v-html="storeInfo.alcohol_text"
    ></p>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Proposition65WarningSymbol from "@/components/UI/Proposition65WarningSymbol.vue";

export default {
  name: "AlcoholWarning",
  components: {
    Proposition65WarningSymbol,
  },
  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
  },
  props: { xs: Boolean },
};
</script>

